<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-分销-分销订单
      -->
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
<!--        <el-form-item label="佣金结算">-->
<!--          <el-select v-model="formInline.is_settled" placeholder="是否结算佣金">-->
<!--            <el-option label="全部" value="-1"></el-option>-->
<!--            <el-option label="已结算" value="1"></el-option>-->
<!--            <el-option label="未结算" value="0"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="用户id" ><el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input></el-form-item>-->
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="onSubmit(formInline.user_id)">查询</el-button></el-form-item>
        <el-form-item><el-button type="primary" @click="goBack()">返回业务员列表</el-button></el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_master.create_time" label="商品信息">
            <template slot-scope="scope">
              <div class="product-info p-10-0" v-for="(item, index) in scope.row.order_master.product" :key="index">
                <div class="pic"><img v-img-url="item.image.file_path" alt="" /></div>
                <div class="info">
<!--                  <div class="name gray3">{{ item.product_name }}</div>-->
                  {{ item.product_name }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="referee.value" label="分销商" width="200">
            <template slot-scope="scope">
<!--              <div class="d-s-s d-c">-->
<!--                <div class="d-s-c ww100 border-b-d" v-if="scope.row.first_user_id > 0">-->
                  <p class="referee-name text-ellipsis">
                    <span class="gray9">一级分销商：</span>
                    <span class="blue">{{ scope.row.agent_first.nickName }}</span>
                  </p>
                  <p class="referee-name text-ellipsis">
                    <span class="gray9">用户ID：</span>
                    <span class="gray6">{{ scope.row.agent_first.user_id }}</span>
                  </p>

            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="单价/数量" width="150">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.order_master.product" :key="index">
                <span class="orange">￥{{ item.product_price }}</span>
                ×{{ item.total_num }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="order_master.pay_price" label="实付款" width="200">
            <template slot-scope="scope">
              <span class="fb orange">{{ scope.row.order_master.pay_price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_master.user.nickName" label="买家" width="200"></el-table-column>
          <el-table-column prop="order_master.update_time" label="交易完成时间" width="200"></el-table-column>
          <el-table-column prop="mobile" label="交易状态" width="230">
            <template slot-scope="scope">
              <p>
                <span class="gray9">付款状态：</span>
                {{ scope.row.order_master.pay_status.text }}
              </p>
              <p>
                <span class="gray9">发货状态：</span>
                {{ scope.row.order_master.delivery_status.text }}
              </p>
              <p>
                <span class="gray9">收货状态：</span>
                {{ scope.row.order_master.receipt_status.text }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="order_master.order_no" label="订单号" width="200"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import PlusApi from '@/api/plus.js';
  import statisticalApi from '@/api/statistical.js';

  export default {
    components: {
      /*编辑组件*/

    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        formInline: {
          // is_settled: '-1',
          /*用户ID*/
          user_id: '',
          create_time: '',

        },
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        /* 当前显示的商品返佣详情 */
        is_show_detail:false,
        currentShowProduct:[],
        create_time: '',
      };
    },
    props: {},
    watch: {
      $route(to, from) {
        if (to.query.user_id != null) {
          this.formInline.user_id = to.query.user_id;
        } else {
          this.formInline.user_id = '';
        }
        this.curPage = 1;
        this.getData();
      }
    },
    created() {
      if (this.$route.query.user_id != null) {
        this.formInline.user_id = this.$route.query.user_id;
      }
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*获取数据*/
      getData(user_id) {
        let self = this;
        console.log(self.formInline.create_time);
        console.log(self.formInline.user_id)
        let Params = {
          user_id: self.formInline.user_id,
          page: self.curPage,
          list_rows: self.pageSize,
          create_time: self.formInline.create_time,

          // is_settled: self.is_settled
        };

        statisticalApi.agentOrder(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      //搜索
      onSubmit() {
        let self = this;
        self.loading = true;
        // self.is_settled = self.formInline.is_settled;
        self.create_time = self.formInline.create_time;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
      /*每页多少条*/
      goBack() {
        let self = this;
        // let user_id = e;
        this.$router.push({
          path: '/plus/statistical',

        });
      },


      /*打开弹出层编辑*/
      editClick(item) {
        this.userModel = item;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },
      // 显示返佣详情
      showDetail(detail){
        this.currentShowProduct = detail;
        this.is_show_detail = true;

      },

      /*关闭添加*/
      closeDetail(e){
        this.is_show_detail=false;
        this.currentShowProduct = {};
      },
    }
  };
</script>

<style scoped="">
  /*.referee-name{ width: 33.333333%;}*/
</style>



// WEBPACK FOOTER //
// src/views/plus/statistical/detail/detail.vue